export const categoryPage = {
  breadcrumb: [{ name: 'Categories', url: '/category' }],
  backUrl: '/',
};
export const productPage = {
  breadcrumb: [{ name: 'Products', url: '/product' }],
  backUrl: '/',
};
export const productInfoPage = {
  breadcrumb: [{ name: 'Products', url: '/product' }],
  backUrl: '/product',
};
export const transactionListPage = {
  breadcrumb: [{ name: 'Transaction List', url: '/transactions' }],
  backUrl: '/transactions',
};
export const customerPage = {
  breadcrumb: [{ name: 'Customers', url: '/customer' }],
  backUrl: '/',
};
export const customerInfoPage = {
  breadcrumb: [{ name: 'Customers', url: '/customer' }],
  backUrl: '/customer',
};
export const orderListPage = {
  breadcrumb: [{ name: 'Order List', url: '/orders' }],
  backUrl: '/orders',
};

export const ticketListPage = {
  breadcrumb: [{ name: 'Ticket List', url: '#' }],
  backUrl: `/ticket`,
};

export const ticketPage = {
  breadcrumb: [
    {
      name: 'Ticket List',
      url: `/ticket`,
    },
    {
      name: 'Ticket Blow Up',
      url: '#',
    },
  ],
  pageInfo: 'Ticket detail',
  backUrl: `/ticket`,
};

export const tagPage = {
  breadcrumb: [{ name: 'Tag', url: '/tag' }],
  backUrl: '/',
};
export const tagInfoPage = {
  breadcrumb: [{ name: 'Tag', url: '/tag' }],
  backUrl: '/tag',
};
